import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import FBCAnalytics from '../firebase/FBCAnalytics';
import { projectFirestore } from '../firebase/config';
import Ring from '../loadingIndicator/indicator';
import { ImgGrid } from '../pages/pageElements';


  const imageRef = projectFirestore.collection('images')
        .orderBy('timestamp','desc');


  const ImageGrid = ({ setSelectedImg}) => {
    const [docs, setDocs] = useState([]);
    const [lastDoc, setLastDoc] = useState();
    const [loading, setLoading] = useState(false);
    const [isEmpty, setIsEmpty] = useState(false);


    useEffect(() => {
        imageRef
        .limit(9)
        .get()
        .then((collections) =>{

          const isCollectionEmpty = collections.size === 0;
          if(!isCollectionEmpty){

          const images = collections.docs.map((image) => image.data())
          setDocs(images);
          const lastDoc = collections.docs[collections.docs.length - 1];
          setLastDoc(lastDoc);
          
          }else{
            setIsEmpty(true)
          }
          setLoading(false);
          
        })

        /*.onSnapshot(snap => {
          let documents = [];
          snap.forEach(doc => {
            documents.push({...doc.data(), id: doc.id});
          });

          const lastDoc = documents.length -1;
          setDocs(documents);
          setLastDoc(lastDoc);*/

      // this is a cleanup function that react will run when
      // a component using the hook unmounts
    }, []);
  

  if(docs.length === 0){
   return <Ring/>;
  }

  
  const fetchMore =()=>{
    setLoading(true);
    imageRef
    .startAfter(lastDoc)
    .limit(9)
    .get()
    .then((collections) =>{
      const isCollectionEmpty = collections.size === 0;

      if(!isCollectionEmpty){

        const images = collections.docs.map((image) => image.data())
        setDocs(docs =>[...docs,...images])
        const lastDoc = collections.docs[collections.docs.length - 1];
        setLastDoc(lastDoc);
       
      }else{
        setIsEmpty(true)
      }

       setLoading(false);
    });
    
  }

 

 return (
  <div>
    
    <ImgGrid>
      {docs.map((doc,index) =>{

        return(
          <motion.div className="img-wrap" key={index} 
            layout
            whileHover={{scale:1.03 }}
            whileTap={{scale:0.99}}
            onClick={() => setSelectedImg(doc.url)}
          >
            <motion.img src={doc.url} alt="artwork image"
              initial={{opacity:0}}
              animate={{opacity:1}}
              transition={{delay:1}}
              whileFocus={<FBCAnalytics title={index} message={"Focus"}/>}
              whileHover={<FBCAnalytics title={index} message={"Hover"}/>}
              whileDrag={<FBCAnalytics title={index} message={"Drag"}/>}
              whileTap={<FBCAnalytics title={index} message={"Tap"}/>}
            />
          </motion.div>
        )

      })}

    </ImgGrid>


    {loading && <Ring/>}


    {!loading && 
      <div class="load-more">
        {!isEmpty && 
            <button class="more-button" onClick={fetchMore}>
              SEE MORE
            </button>
        } 
      </div>
    }

    {isEmpty &&
      <div className='isEmpty'>
        <p>Umm, looks like that's it 🤷🏿‍♂️</p>
      </div>
    }

  </div>
 
    
  )
}

export default ImageGrid;